import apiService from "@/api/ApiService";

const FILTERS_CONFIG_URL = "/filters-config/";

export class FilterService {
  async getConfig(params) {
    return (await apiService.get(`${FILTERS_CONFIG_URL}`, { params })).data;
  }
}

const filterService = new FilterService();

export default filterService;
